import { sequence } from 'cerebral'
import { set, wait } from 'cerebral/operators'
import { props } from 'cerebral/tags'
import updateSnackbar from '../actions/updateSnackbar'
import { snackbar } from 'consts'

const { displayTime, animationTime } = snackbar

const removeSnackbar = (controller, id, timer = 0) => {
  setTimeout(
    () =>
      controller.getSignal('app.removeSnackbar')({
        snackbar: { id: id }
      }),
    timer
  )
}

const getAction = ({ close = true, signal = {} }, createTranslationObject) => ({
  ...createTranslationObject,
  signal: {
    args: signal.args || {},
    name: signal.name || ''
  },
  close: close // close the snackbar when clicked
})

export default (text, type = 'normal', sticky = false, action = null) => {
  const snackbar = ({ controller, props, resolve, state, uuid }) => {
    const id = uuid.id()
    const createTranslationObject = { text: { ...resolve.value(text) } }

    state.push(`app.snackbars`, {
      id,
      ...createTranslationObject,
      type,
      visible: 0,
      action: action ? getAction(action, createTranslationObject) : null
    })
    return {
      snackbar: {
        id
      },
      snackbarTimer: sticky ? null : action ? displayTime * 2 : displayTime
    }
  }

  return sequence('createSnackbar', [
    snackbar,
    wait(100), // Fixes paint issues
    set(props`snackbar.visible`, true),
    updateSnackbar,
    ({ controller, props }) => {
      if (props.snackbarTimer)
        removeSnackbar(
          controller,
          props.snackbar.id,
          props.snackbarTimer - animationTime
        )
    }
  ])
}



// WEBPACK FOOTER //
// ./src/modules/App/factories/createSnackbar.js